// @flow
import * as React from "react"
import { FieldTitle } from "componentsStyled/Typography/Titles"
import { formatReadableDateRange } from "data/units/date/formatters"
import { Spread } from "componentsStyled/Layout/Flex"
import { Text } from "componentsStyled/Typography/Texts"

type Props = {
  dates: any,
  originalReservation?: any,
}

const Dates = ({ dates, originalReservation }: Props) => (
  <React.Fragment>
    <FieldTitle>Dates</FieldTitle>
    {originalReservation ? (
      <div>
        <Spread>
          <Text>Previous Dates</Text>
          <Text>{formatReadableDateRange(originalReservation)}</Text>
        </Spread>
        <Spread>
          <Text book>New Dates</Text>
          <Text book>{formatReadableDateRange(dates)}</Text>
        </Spread>
      </div>
    ) : (
      <Text>{formatReadableDateRange(dates)}</Text>
    )}
  </React.Fragment>
)

export default Dates



// WEBPACK FOOTER //
// ./src/pages/Cart/CartForm/Dates/index.js